module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top'), _vm._v(" "), _c('main', {
    staticClass: "container"
  }, [_c('row', [_c('div', {
    staticClass: "col s12"
  }, [_c('markdown-card', {
    attrs: {
      "url": _vm.url
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-06ccffcc!./~/vue-loader/lib/selector.js?type=template&index=0!./assets/js/page/Service.vue
// module id = 68
// module chunks = 0